import { gql } from "@apollo/client";

export const GET_NOTIFICATION_LEDGER_GLOBAL = gql`
  query GetNotificationLedgerGlobal($page: Int!, $limit: Int!) {
    getNotificationLedgerGlobal(page: $page, limit: $limit) {
      _id
      title
      body
      type
      asset
      payload
      isSticky
      image
      masjidId
      expiresAt
      createdBy
      masjids {
        _id
        masjidName
      }
      createdAt
      updatedAt
      status
      lastEditedAt
      cancelledAt
      isGlobal
      noExpiry
      editCount
    }
  }
`;
